import { FC } from 'react';

import type { IntegrationResponse } from '@/entities/integrations';

import { MockModeSection } from './MockModeSection';
import { ScenariosSection } from './ScenariosSection';
import { StatisticsSection } from './StatisticsSection';

type Props = {
  integration: IntegrationResponse;
};

export const TestingTab: FC<Props> = ({ integration }) => {
  return (
    <div className="flex flex-col gap-4">
      <MockModeSection integration={integration} />
      <StatisticsSection code={integration.code} />
      <ScenariosSection code={integration.code} mockMode={Boolean(integration.mockMode)} />
    </div>
  );
};
